/**
 * Resolve callable contacts for a property (partners by sub-register, then admins).
 */
export function resolvePropertyContacts(property, partners = [], admins = []) {
  if (!property) return [];

  const srId = property.sub_register_id || property.extra_fields?.sub_register_id;

  if (srId) {
    const matched = (partners || []).filter((p) => {
      const arr = Array.isArray(p.sub_registers)
        ? p.sub_registers
        : Array.isArray(p.sub_register)
          ? p.sub_register
          : p.sub_register != null
            ? [p.sub_register]
            : [];
      return arr.map(Number).includes(Number(srId));
    });

    if (matched.length > 0) {
      return matched
        .map((p) => ({
          name: p.name || p.partner_name,
          phone: p.phone || p.partner_phone,
          isAdmin: false,
        }))
        .filter((c) => c.phone);
    }
  }

  return (admins || [])
    .filter((a) => a.show_user)
    .map((a) => ({
      name: a.admin_name || a.name,
      phone: a.admin_phone || a.phone,
      isAdmin: true,
    }))
    .filter((c) => c.phone);
}

export function normalizePhoneDigits(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 10) return `91${digits}`;
  return digits;
}

export function getPrimaryPropertyContact(property, partners, admins) {
  const contacts = resolvePropertyContacts(property, partners, admins);
  return contacts[0] || null;
}
